import { render, staticRenderFns } from "./Programma.vue?vue&type=template&id=3ebe2619&"
import script from "./Programma.vue?vue&type=script&lang=js&"
export * from "./Programma.vue?vue&type=script&lang=js&"
import style0 from "./Programma.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports